// extracted by mini-css-extract-plugin
export default {"skeleton-height-500px":"skeleton-height-500px_DSD10pPv","skeleton-max-width-300px":"skeleton-max-width-300px_RsaF50gV","skeleton-max-width-400px":"skeleton-max-width-400px_LzoVGJWI"};